export default function initToolChooser() {
    const choosers = document.querySelectorAll('.tool-chooser .persona-chooser-full');
    const toolCards = document.querySelectorAll('.tool-chooser .tool-card');

	function selectPill(pill, chooserElement, saveToStorage = true, isInitial = false) {
		const pills = chooserElement.querySelectorAll('.persona-pill');

        if( pill.classList.contains('selected') ) {
            pill.classList.remove('selected');
            pill.dataset.selected = 'false';
        } else {
            pill.classList.add('selected');
            pill.dataset.selected = 'true';
        }
		
        /** loop through pills and add pill's data-persona to an array "selectedPersonas" if pill has selected class.
        then loop through toolCards and check if toolCards list of data-personas matches any entries in the selectedPersonas array. If true, add class "active" to the toolCard, if not, remove the "active" class.
        the data-personas is a comma separated list of personas. */
        const selectedPersonas = [];
        pills.forEach(pill => {
            if( pill.dataset.selected === 'true' ) {
                selectedPersonas.push(pill.dataset.persona);
            }
        });
        console.log(selectedPersonas);
        if( selectedPersonas.length == 0 ) {
            toolCards.forEach(toolCard => {
                toolCard.classList.add('active');
                toolCard.classList.remove('not-active');
            });
            return;
        }
        
        toolCards.forEach(toolCard => {
            const personas = toolCard.dataset.personas.split(',');
            if( selectedPersonas.some(persona => personas.includes(persona)) ) {
                toolCard.classList.add('active');
                toolCard.classList.remove('not-active');
            } else {
                toolCard.classList.remove('active');
                toolCard.classList.add('not-active');
            }
        });

	}
	
	choosers.forEach(chooserElement => {
		const pills = chooserElement.querySelectorAll('.persona-pill');
			
		pills.forEach(pill => {
			pill.addEventListener('click', function() {
				selectPill(this, chooserElement, true, false);
			});
		});
	});

}
